<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">仓库管理</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search"
                     @click="submitQuery(1)">刷新
          </el-button>
          <el-button class="btn btn-primary" type="primary" size="small"
                     @click="$router.push({name:'repositoryAdd'})">添加
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>仓库列表</span>
    </div>
    <el-table highlight-current-row :data="sellers" border>
      <el-table-column align="center" label="序号" type="index"/>
      <el-table-column align="center" label="仓库名称" prop="name"/>
      <el-table-column align="center" label="联系人/寄件人姓名" prop="linkman"/>
      <el-table-column align="center" label="登录名" prop="loginName"/>
      <el-table-column align="center" label="简要地址" prop="briefAddress"/>
      <el-table-column align="center" label="仓库图片">
        <template slot-scope="scope">
          <el-image style="height: 100px; width: 100px;" :src="dynamicPath+scope.row.iconPath">
            <div slot="error" class="image-slot">
              <el-image title="加载失败"
                        src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png"/>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="600px">
        <template slot-scope="scope">
          <el-button type="primary" size="mini"
                     @click="$common.goRouterLink({ name: 'repositoryDetail', query: { sellerId: scope.row.id }})">
            修改
          </el-button>
          <el-button type="error" size="mini"
                     @click="del(scope.row.id)">
            删除
          </el-button>

        </template>
      </el-table-column>
    </el-table>
    <vue-pager :datafile="fillData" url="/seller/pageSeller" :query="query" ref="pager"
               :init="true"></vue-pager>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: {},
      sellers: [],
      dynamicPath:config.dynamicResourcePath
    }
  },
  methods: {
    fillData(_response) {
      this.sellers = _response.items || [];
    },
    submitQuery(_num) {
      this.$refs.pager.gotoPage(_num);
    },
    deleteActiveType: function (_sellerId) {
      var _this = this;
      _this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$common.ajaxRequest({
          url: '/seller/deleteSeller',
          data: {
            sellerId: _sellerId
          },
          success(response) {
            _this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.submitQuery();
              }
            });
          }
        })
      }).catch(() => {
        console.log('delete cancel');
      });
    },
    del(_id) {
      var _this = this;
      _this
          .$confirm("此操作会造成数据丢失等，是否继续？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            _this.$common.ajaxRequest({
              url: '/seller/deleteSeller',
              data: {
                sellerId: _id
              },
              success(response) {
                _this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 1000,
                  onClose: function () {
                    _this.submitQuery(1);
                  }
                });
              }
            });
          })
          .catch(() => {
            console.log("delete cancel");
          });
    },
  },
}
</script>